(function() {
	'use strict';
	angular.module('app.core')
		.service('supplyOrderForecastService', supplyOrderForecast);

	supplyOrderForecast.$inject = ['$http', '$q', 'URLS'];
	function supplyOrderForecast($http, $q, URLS) {
		return {
			getForecastForOrder: getForecastForOrder,
			saveForecast: saveForecast,
			deleteForecast: deleteForecast
		};

		function getForecastForOrder(factoryNdx, orderNdx) {
			var url = URLS.host + String.format(URLS.supplyOrderForecast, factoryNdx, orderNdx);
			var canceller = $q.defer();
			var cancel = function () {
				canceller.promise.isUserCancelled = true;
				canceller.resolve('Cancelled');
			};

			var promise = $http.get(url, {
				timeout: canceller.promise
			}).then(getForecastForOrderSuccess)
				.catch(getForecastForOrderFailed);

			return {
				promise: promise,
				cancel: cancel
			};

			function getForecastForOrderSuccess(response) {
				var data = response.data;
				if (data) {
					data.forEach(function(forecast) {
						var dtTemp = new Date(forecast.forecastDate);
						var dt = moment(dtTemp).add(dtTemp.getTimezoneOffset(), 'minutes');
						forecast.forecastDate = dt.valueOf();
					});
				}
				return response;
			}

			function getForecastForOrderFailed(error) {
				return error;
			}
		}

		function saveForecast(factoryNdx, orderNdx, forecast) {
			var url = URLS.host + String.format(URLS.supplyOrderForecast, factoryNdx, orderNdx);
			return $http.post(url, forecast)
				.then(saveForecastSuccess)
				.catch(saveForecastFailed);

			function saveForecastSuccess(response) {
				return response.data;
			}

			function saveForecastFailed(error) {
				return error;
			}
		}

		function deleteForecast(factoryNdx, orderNdx) {
			var url = URLS.host + String.format(URLS.supplyOrderForecast, factoryNdx, orderNdx);
			return $http.delete(url)
				.then(deleteForecastSuccess)
				.catch(deleteForecastFailed);

			function deleteForecastSuccess(response) {
				return response.data;
			}

			function deleteForecastFailed(error) {
				return error;
			}
		}
	}
})();